import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../request'
import styles from '../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import rightAuth from "../../components/_utils/userRights";
import { RightsWrapper } from '../../components/_utils/utils'
const TabPane = Tabs.TabPane


@Form.create()
class AllTrainings extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    universities: [],
    allUsers: [],
    universityType: null,
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      let response = await Request.getTrainingDetails(params)
      this.setState({ total: response.total, universityType: response.doc && response.doc.universityType ? response.doc.universityType : null })
      resolve(response)
    })
  }

  getAllBoardCategories = async () => {
    let response = await Request.getBoardCategoryDetails({
      results: 1000,
      count: 1000,
    })
    return response
  }

  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateTrainingDetails(values)
        } else {
          x = await Request.addTrainingDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0'
          })
          notification.success({
            message: this.state.id
              ? `Traning Details Updated Successfully`
              : 'Training Details Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
              university: '',
              users: '',
              date: '',
              time: '',
              trainingType: '',
              meetingLink: '',
              meetingLocation: '',
              meetingId: '',
              meetingPassword: ''
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteTrainingDetails = async data => {
    this.setState({ loading: true })
    await Request.deleteTrainingDetails(data)
    this.setState({ loading: false })
    this.table.current.reload();
    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setTrainingDetailsData(companyDetailId) {
    if (companyDetailId) {
      Request.trainingDetailById({ id: companyDetailId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1'
            })
            if (doc.trainingType === "Virtual") {
              this.setState({ virtualMeeting: true, faceToFace: false })
            } else {
              this.setState({ virtualMeeting: false, faceToFace: true })
            }
            this.props.form.setFieldsValue({
              university: doc.university,
              users: doc.users,
              date: moment(doc.date),
              time: doc.time,
              trainingType: doc.trainingType,
              meetingLink: doc.meetingLink,
              meetingLocation: doc.meetingLocation,
              meetingId: doc.meetingId,
              meetingPassword: doc.meetingPassword
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }

  loadUsers = async () => {
    let usersParams = {
      sortField: '_id',
      sortOrder: 'ascend',
      results: 200,
      active: true,
      userType: { $ne: "Student" }
    }
    let userResponse = await Request.loadUser({ ...usersParams, regExFilters: ['name'] })
    let allUsers = []
    _.each(userResponse.data, (user) => {
      allUsers.push({ id: user._id, display: user.name })
    })

    this.setState({ allUsers });
  }

  loadApis = async () => {
    this.loadUsers();
    let universityParams = {
      results: 10000,
      count: 10000
    }
    let universityResponse = await Request.getUniversities(universityParams)
    let universities = []
    _.each(universityResponse.data, (university) => {
      universities.push({ id: university._id, display: university.universityInstitutionName })
    })


    this.setState({ universities })
  }



  componentWillMount() {

  }

  async componentDidMount() {
    this.loadApis()
  }

  handleSearchUniversity = _.debounce(async (value) => {
    if (!value) return;

    try {
      const params = {
        search: value,
        limit: 50,
      };

      const res = await Request.getUniversities(params);

      const universities = res.data.map(u => ({
        id: u._id,
        display: u.universityInstitutionName
      }));

      this.setState({ universities });
    } catch (error) {
      console.error('Search failed:', error);
    }
  }, 400);



  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }
  render() {
    const {
      form: { getFieldDecorator, setFieldsValue }
    } = this.props
    const { id } = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'University Type',
          key: 'universityType',
          type: 'select',
          required: true,
          options: ['New University', 'Existing University'],
          onChange: v => {
            setFieldsValue({ universityType: v }, () => {
              this.setState({ universityType: v })
            })
          }
        },
        {
          label: "University Name",
          key: "university",
          required: this.state.universityType === "Existing University",
          hidden: this.state.universityType !== "Existing University",
          type: 'select',
          showSearch: true,
          options: this.state.universities,
          onSearch: this.handleSearchUniversity,
          filterOption: false, // disables client-side filtering
          onChange: v => setFieldsValue({ university: v })
        },
        {
          label: "University Name",
          key: "universityName",
          required: this.state.universityType === "New University",
          hidden: this.state.universityType !== "New University"
        },
        {
          label: "Users",
          key: "users",
          type: 'select',
          required: true,
          mode: 'multiple',
          options: this.state.allUsers,
          required: true,
          onChange: v => {
            this.props.form.setFieldsValue({ users: v })
          }
        },
        {
          label: 'Date',
          key: 'date',
          type: 'date',
          required: true,
          customProps: {
            disabledDate: d => !d || d.isBefore(moment().add(-1, 'day'))
          }
        },
        {
          label: 'Time',
          key: 'time',
          type: 'time',
          required: true
        },
        {
          label: 'Training Type',
          key: 'trainingType',
          type: 'select',
          required: true,
          options: ["Virtual", "Face To Face"],
          onChange: v => {
            setFieldsValue({ trainingType: v })
            if (v === "Virtual") {
              this.setState({ virtualMeeting: true, faceToFace: false })
            } else {
              this.setState({ virtualMeeting: false, faceToFace: true })
            }
          }
        },
        {
          label: 'Virtual Meeting Link',
          key: 'meetingLink',
          required: this.state.virtualMeeting,
          hidden: !this.state.virtualMeeting
        },
        {
          label: 'Meeting Location',
          key: 'meetingLocation',
          required: this.state.faceToFace,
          hidden: !this.state.faceToFace
        },
        {
          label: 'Meeting Id',
          key: 'meetingId',
          hidden: !this.state.virtualMeeting
        },
        {
          label: 'Meeting Password',
          key: 'meetingPassword',
          hidden: !this.state.virtualMeeting
        },
      ]
    };

    const columns = [
      {
        title: 'University Name',
        key: 'university',
        dataIndex: 'university.universityInstitutionName',
        render: (text, record) => (
          record.university ? record.university.universityInstitutionName : record.universityName
        )
      },
      {
        title: 'Users',
        key: 'users',
        dataIndex: 'users.name',
        render: (text, record) => {
          return record.users ? (
            <ul>
              {record.users.map((val, inde) => {
                return <li key={inde}>{val.name}</li>
              })}
            </ul>
          ) : null
        }
      },
      {
        title: 'Training Date',
        key: 'date',
        dataIndex: 'date',
        render: (text, record) => (
          <span>{moment(text).format('DD-MM-YYYY')}</span>
        )
      },
      {
        title: 'Training Time',
        key: 'time',
        dataIndex: 'time'
      },
      {
        title: 'Training Type',
        key: 'trainingType',
        dataIndex: 'trainingType'
      },
      {
        title: 'Meeting Link/Location',
        key: 'link',
        dataIndex: 'link',
        render: (text, record) => (
          record.trainingType === "Virtual" ? record.meetingLink : record.meetingLocation
        )
      },
      {
        title: 'Meeting Id/Password',
        key: 'meetingIdPass',
        render: (text, record) => (
          record && (record.meetingId || record.meetingPassword) ? `${record.meetingId ? record.meetingId : ''}/${record.meetingPassword ? record.meetingPassword : ''}` : ''
        )
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'trainings.edit'}>
              <Tooltip title="Edit Training">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setTrainingDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'trainings.delete'}>
              <Tooltip title="Delete Training Detail">
                <Popconfirm
                  title="Are you sure delete this Training Detail?"
                  onConfirm={() => {
                    this.deleteTrainingDetails({ _id: record._id })
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Training Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Tranings`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 900 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Training '} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllTrainings
